import PropTypes from 'prop-types';

export const BasicReportRowPropTypes = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  descr: PropTypes.string.isRequired,
  columnsData: PropTypes.arrayOf(PropTypes.number),
});

export const ReportSummaryRowPropTypes = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  descr: PropTypes.string.isRequired,
  columnsData: PropTypes.arrayOf(PropTypes.number).isRequired,
  section: PropTypes.string.isRequired,
});

const subrowsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  amount: PropTypes.number.isRequired,
  columnsData: PropTypes.arrayOf(PropTypes.number).isRequired,
  descr: PropTypes.string.isRequired,
  tagDescription: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired,
}));

subrowsPropTypes.subrows = subrowsPropTypes;

export const ReportTagGroupRowPropTypes = PropTypes.shape({
  tagName: PropTypes.string.isRequired,
  tagDescription: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  subrows: subrowsPropTypes.isRequired,
});

export const EffectiveTaxRateReportPropTypes = PropTypes.shape({
  beginningRows: PropTypes.arrayOf(BasicReportRowPropTypes.isRequired).isRequired,
  summaryRows: PropTypes.arrayOf(ReportSummaryRowPropTypes.isRequired).isRequired,
  tagsGroups: PropTypes.arrayOf(ReportTagGroupRowPropTypes.isRequired).isRequired,
});

export const DetailedCountryTaxTypesDataPropTypes = PropTypes.arrayOf(PropTypes.shape({
  countryTaxType: PropTypes.string.isRequired,
  taxRate: PropTypes.number.isRequired,
  description: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
}));
